import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { AuthorizedSignerReducedFragmentDoc } from '../fragments/authorizedSignerReduced.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateAuthorizedSignerMutationVariables = Types.Exact<{
  event_account_id: Types.Scalars['ID'];
  name: Types.Scalars['String'];
}>;


export type CreateAuthorizedSignerMutation = { __typename?: 'Mutation', createAuthorizedSigner: { __typename?: 'AuthorizedSigner', id: string, name: string } };


export const CreateAuthorizedSignerDocument = gql`
    mutation CreateAuthorizedSigner($event_account_id: ID!, $name: String!) {
  createAuthorizedSigner(event_account_id: $event_account_id, name: $name) {
    ...AuthorizedSignerReduced
  }
}
    ${AuthorizedSignerReducedFragmentDoc}`;
export type CreateAuthorizedSignerMutationFn = Apollo.MutationFunction<CreateAuthorizedSignerMutation, CreateAuthorizedSignerMutationVariables>;

/**
 * __useCreateAuthorizedSignerMutation__
 *
 * To run a mutation, you first call `useCreateAuthorizedSignerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAuthorizedSignerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAuthorizedSignerMutation, { data, loading, error }] = useCreateAuthorizedSignerMutation({
 *   variables: {
 *      event_account_id: // value for 'event_account_id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateAuthorizedSignerMutation(baseOptions?: Apollo.MutationHookOptions<CreateAuthorizedSignerMutation, CreateAuthorizedSignerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAuthorizedSignerMutation, CreateAuthorizedSignerMutationVariables>(CreateAuthorizedSignerDocument, options);
      }
export type CreateAuthorizedSignerMutationHookResult = ReturnType<typeof useCreateAuthorizedSignerMutation>;
export type CreateAuthorizedSignerMutationResult = Apollo.MutationResult<CreateAuthorizedSignerMutation>;
export type CreateAuthorizedSignerMutationOptions = Apollo.BaseMutationOptions<CreateAuthorizedSignerMutation, CreateAuthorizedSignerMutationVariables>;